import './Sponsorship.scss';

import upload from '../../assets/images/icons/upload.svg';
import sortIcon from '../../assets/images/icons/sort.svg';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useState, useEffect } from 'react';
import axios from 'axios';
import TopNav from '../../components/TopNav/TopNav';
import SideBar from '../../components/SideBar/SideBar';

function Sponsorship() {
    const sorts = ['venue', 'time', 'amount', 'status'];
    const headings = ['Venue', 'Time', 'Amount', 'Status', 'Decline'];
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <main>
            <TopNav />
            <div className='main-container'>
                <SideBar />
                <article style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <section className='sponsorship'>
                        <div className='sponsorship__top'>
                            <h1 className='sponsorship__top-heading'>
                                Sponsor requests
                            </h1>

                            <button className='sponsorship__top-clear'>
                                <p className='sponsorship__top-clear-text'>
                                    Export data
                                </p>
                                <img className='sponsorship__top-clear-icon' src={upload} alt='upload icon'></img>
                            </button>
                        </div>

                        <section className='no-data'>
                            <div className='no-data__container'>
                                <p className='no-data__container-text'>
                                    There is no sponsorship data at this time
                                </p>

                            </div>
                        </section>

                        {/* <section className='sponsorship__info'>
                            <Box sx={{ width: '100%', bgcolor: 'transparent' }}>
                                <TabContext value={value}>
                                    <TabList onChange={handleChange} variant='fullWidth'>
                                        <Tab sx={{ width: '50%', color: '#FFF' }} label="Sponsor venues" value='1' />
                                        <Tab sx={{ width: '50%', color: '#FFF' }} label="Sponsor events" value='2' />
                                    </TabList>
                                    <TabPanel value='1'>
                                        <section className='sponsorship__info-venues'>
                                            <div className='sponsorship__info-venues-sorts'>
                                                {
                                                    sorts.map((sort, index) => (
                                                        <button key={index} className='sponsorship__info-venues-sorts-button'>
                                                            <p className='sponsorship__info-venues-sorts-button-text'>
                                                                Sort by {sort}
                                                            </p>
                                                            <img className='sponsorship__info-venues-sorts-button-icon' src={sortIcon} alt='three cascading horizontal lines'></img>
                                                        </button>
                                                    ))
                                                }
                                            </div>

                                            <table className='sponsorship__info-venues-table'>
                                                <thead className='sponsorship__info-venues-table-top'>
                                                    <tr className='sponsorship__info-venues-table-top-headings'>
                                                        {
                                                            headings.map((heading, index) => (
                                                                <th key={index} className='sponsorship__info-venues-table-top-headings-heading'>
                                                                    {heading}
                                                                </th>
                                                            ))
                                                        }
                                                    </tr>
                                                </thead>
                                            </table>
                                        </section>
                                    </TabPanel>
                                </TabContext>
                            </Box>
                        </section> */}
                    </section>

                </article>
            </div>
        </main>
    )
}

export default Sponsorship;